import { Text } from '@chakra-ui/react'

import { faq } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import ModalV3 from '@/components/UI/Modal/ModalV3'

import type { ModalState } from './types'

export default function AppContextModalBlocked({
  modalState,
  hideModal,
}: {
  modalState: ModalState | null
  hideModal: () => void
}): React.ReactElement {
  return (
    <ModalV3
      title="Account Suspended"
      size="xl"
      open
      onClose={hideModal}
      body={() => (
        <Text>
          Your account needs to be approved before you can {modalState?.actionName}. If you have any
          questions about your suspension, please contact{' '}
          <ShwLink href={faq.getArticleUrl('how-do-i-contact-the-schoolhouse-team')}>
            User Support
          </ShwLink>
          .
        </Text>
      )}
    />
  )
}
